import { jsx as _jsx } from "react/jsx-runtime";
import { RecordingIndicator } from '@streamr/tv-ui';
import { useRef } from 'react';
import { BroadcastService } from '../../../services/broadcast/BroadcastService';
import { RecordingService } from '../../../services/recording/RecordingService';
import { assert } from '../../../utils/assert';
import { BottomLeft } from '../../../utils/popups';
import { PopupCssPreset } from '../../popups/Popup.styles';
import { showStartRecordingPopup } from '../../popups/recording/StartRecordingPopup';
import { showStopRecordingPopup, } from '../../popups/recording/StopRecordingPopup';
import { showToast } from '../../popups/ToastPopup';
const mobilePositioningForStopRecordingPopup = {
    fullscreenOnly: true,
};
const desktopPositioningForStopRecordingPopup = {
    fullscreenOnly: false,
    translateFn: BottomLeft,
    popupCssPresetForDesktop: PopupCssPreset.AnchoredBottomRight,
};
export const RecordingStatusIndicator = ({ isMobile, broadcast, }) => {
    const anchorRef = useRef(null);
    const activeRecording = RecordingService.getOutput().useActiveRecording();
    const isBroadcasting = BroadcastService.getOutput().useBroadcasting();
    const onStopRecording = async () => {
        assert(activeRecording, 'Recording is not active');
        const shouldStop = await showStopRecordingPopup({
            anchorRef,
            positioning: isMobile
                ? mobilePositioningForStopRecordingPopup
                : desktopPositioningForStopRecordingPopup,
            broadcast,
            isPublic: activeRecording.visibility === 'public',
        });
        if (shouldStop) {
            RecordingService.getNotificationInterface().notifyStopRecording();
        }
    };
    const onCancelInitialization = () => {
        RecordingService.getNotificationInterface().notifyStopRecording();
    };
    const onRetry = () => {
        RecordingService.getNotificationInterface().notifyRetryInitialization();
    };
    const onButtonClick = async () => {
        if (!isBroadcasting) {
            showToast('You need to Go Live first to start recording');
            return;
        }
        if (!activeRecording) {
            const access = await showStartRecordingPopup({
                anchorRef,
                variant: isMobile ? 'mobile' : 'desktop',
            });
            if (access) {
                RecordingService.getNotificationInterface().notifyStartRecording(
                /**
                 * @todo This is incorrect. `broadcast` is not a full Broadcast object,
                 *       but RecordingService expects it to be. Either make RecordingService
                 *       accept a partial Broadcast, or fetch the full Broadcast object here!
                 */
                broadcast, access);
            }
            return;
        }
        if (activeRecording.status === 'recording') {
            // biome-ignore lint/nursery/noFloatingPromises: TODO
            onStopRecording();
        }
        else if (activeRecording.status === 'initializing') {
            onCancelInitialization();
        }
        else if (activeRecording.status === 'error') {
            onRetry();
        }
    };
    return (_jsx("div", { ref: anchorRef, children: _jsx(RecordingIndicator, { status: activeRecording?.status ?? 'not_recording', onButtonClick: onButtonClick, shape: isMobile ? 'circle' : 'square', title: "Record" }) }));
};
